import React, { useState, useRef, useCallback } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTheme } from '@material-ui/core/styles'
import { BasePopper } from './'
import { useTranslation } from 'react-i18next'

const borderColor = '#aaaaaa'
const defaultPlacement = 'bottom'
const preventOverflow = 'scrollParent'
const maxWidth = '200px'
const defaultPadding = '8px'
const defaultBorderRadius = '6px'

const MessageContainer = styled.div`
  padding:${defaultPadding};
  border-radius: ${defaultBorderRadius};
  border: 1px solid ${borderColor};
  max-width: ${maxWidth};
  background-color: ${props => props.theme.palette.background.default};
`

const ClickElContainer = styled.div`
  display: inline-block;
`

/**
 * Implements ToolTip for a react element.
 *
 * @param {object} props component props
 * @returns {ToolTip} ToolTip component
 */
const ToolTip = props => {
  const { t } = useTranslation()
  const anchorRef = useRef(null)
  const [open, setOpen] = useState(false)
  const theme = useTheme()

  const onMouseOut = useCallback(() => {
    setOpen(false)
  }, [])

  const onMouseOver = useCallback(() => {
    setOpen(true)
  }, [])

  return (
    <>
      <ClickElContainer style={props.style} ref={anchorRef} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>{props.children}</ClickElContainer>
      <BasePopper
        size='small'
        arrowBorderColor={borderColor}
        arrow={true}
        open={open}
        anchorEl={anchorRef.current}
        placement={props.placement || defaultPlacement}
        flip={true}
        preventOverflow={preventOverflow}
        id={props.id}
        popperBody={
          <MessageContainer style={props.messageStyle} theme={theme} noTranslate={true}>
            {t(props.message)}
          </MessageContainer>
      }
    />
    </>
  )
}

ToolTip.propTypes = {
  /**
   id for the control.
   */
  id: PropTypes.string,
  /**
   * The element for which the tooltip displays when hovering.
   */ 
  children: PropTypes.node.isRequired,
  /**
   * The message to be displayed in the tooltip.
   */ 
  message: PropTypes.string.isRequired,
  /**
   Prevents the language translation of the label.
   */
  // noTranslate: PropTypes.bool,
  /**
   Tooltip placement relative to the tooltipEl.
   */
  placement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  /**
   Style applied to the wrapper of the children. Sometimes icons spill over their visual profile vertically. Use height to fix this.
   */
  style: PropTypes.object,
  /**
   Style applied to the wrapper of the message.
   */
  messageStyle: PropTypes.object,
}

export default ToolTip